import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({
  isActive: false,
})

const adBlocker = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SET_ADBLOCKER_STATUS:
      return state.set('isActive', payload)
    default:
      return state
  }
}

export default adBlocker
